import { createTheme } from "@mui/material/styles";

export const theme = createTheme({
    palette: {
        primary: { main: "#DF1440" },
        secondary: { main: "#000000" },
    }
});